import {
  FeedbackParams,
  RecommendArtist,
  CommonListParams,
  SearchTestSetItem,
  CommonListResponse,
  SearchTestSetParams,
  TestSetParamsType,
  SaveTestSetFormValuesType,
} from 'common/types';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import { AiRecommendArtist } from 'common/components/TaskPublish/common';

export const recommend = {
  getRecommendedArtists: (params: TestSetParamsType) => {
    return FastApiAxiosInstance.post<CommonListResponse<AiRecommendArtist> & { recommendTaskId: number }>(
      '/api/v1/recommend/getArtist',
      params,
    );
  },
  getTestSetList: (params: CommonListParams & SearchTestSetParams) => {
    return FastApiAxiosInstance.post<CommonListResponse<SearchTestSetItem>>('/api/v1/recommend/testSet/search', params);
  },
  saveTestSet: (params: SaveTestSetFormValuesType) => {
    return FastApiAxiosInstance.post<{ recommendTaskId: number }>('/api/v1/recommend/testSet/save', params);
  },
  feedback: (params: FeedbackParams) => {
    return FastApiAxiosInstance.post<{ recommendTaskId: number }>('/api/v1/recommend/feedback', params);
  },
  permission: () => {
    return FastApiAxiosInstance.get<{ search: boolean; saveTestSet: boolean }>('/api/v1/recommend/permission');
  },
};
